module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar entityContext = (config || {}).entityContext || 'mailing';\n%>\n<div>\n<section class=\"top\">\n<section class=\"left\">\n<h1><%= storage.__(config.titleKey || ''); %></h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }); %>\n<%- include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }); %>\n</section>\n</section>\n<section class=\"bottom\">\n<%- helpers.renderSection('filter'); %>\n<%- helpers.renderSection('mailings'); %>\n</section>\n</div>"
  , __filename = "components/templates/newsletter/mailings/controller.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var entityContext = (config || {}).entityContext || 'mailing';

    ; __line = 3
    ; __append("\n<div>\n<section class=\"top\">\n<section class=\"left\">\n<h1>")
    ; __line = 7
    ; __append(escapeFn( storage.__(config.titleKey || '') ))
    ; __append("</h1>\n</section>\n<section class=\"center\"></section>\n<section class=\"right\">\n")
    ; __line = 11
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'refresh', context: entityContext, symbolOnly: false } }) )
    ; __append("\n")
    ; __line = 12
    ; __append( include('../../../base/form/elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: entityContext, symbolOnly: false, positive: true } }) )
    ; __append("\n</section>\n</section>\n<section class=\"bottom\">\n")
    ; __line = 16
    ; __append( helpers.renderSection('filter') )
    ; __append("\n")
    ; __line = 17
    ; __append( helpers.renderSection('mailings') )
    ; __append("\n</section>\n</div>")
    ; __line = 19
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/mailings/controller.ejs

}